import React, { useRef, useState } from "react";
import "../ACVExtension/ACVExtension.css";
import ConfirmDialog from "../Assignment/Components/ConfirmDialog/ConfirmDialog";
import { useTranslation } from "react-i18next";
import { ReCaptcha } from "../../components/ReCaptcha";
import { CircularProgress, IconButton } from "@mui/material";
import {
  drawCaptchaOnCanvas,
  generateCaptchaText,
} from "../../utils/reCaptcha";
import DefaultExtensions from "./DefaultExtensions";

function ACVExtension(props) {
  const [storeExtention, setStoreExtention] = useState({});
  const extensions = DefaultExtensions(props, storeExtention);
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = useState(false);
  const [captchaText, setCaptchaText] = useState("");
  const [userInput, setUserInput] = useState("");
  const canvasRef = useRef(null);
  const { t } = useTranslation();

  const initializeCaptcha = (ctx) => {
    setUserInput("");
    const newCaptcha = generateCaptchaText();
    setCaptchaText(newCaptcha);
    drawCaptchaOnCanvas(ctx, newCaptcha);
  };

  return (
    <>
      {isOpenConfirmationModal && (
        <ConfirmDialog
          id="extension-dialog"
          isConfirmDelete={isOpenConfirmationModal}
          setisConfirmDelete={() => {
            setIsOpenConfirmationModal(false);
            props.setCheckInputCaptchaBlankOrNot(false);
          }}
          cancelButton={t("extention").cancel}
          confirmButton={
            <div className="button-confirm">
              {t("extention").continue}
              {props.loader && (
                <IconButton className="loader-button">
                  <CircularProgress className="progressbar-loader" />
                </IconButton>
              )}
            </div>
          }
          content={
            <div className="captcha-content">
              <ReCaptcha
                captchaText={captchaText}
                setCaptchaText={setCaptchaText}
                userInput={userInput}
                setUserInput={setUserInput}
                canvasRef={canvasRef}
                initializeCaptcha={initializeCaptcha}
                setCheckInputCaptchaBlankOrNot={
                  props.setCheckInputCaptchaBlankOrNot
                }
                checkInputCaptchaBlankOrNot={props.checkInputCaptchaBlankOrNot}
              />
              {t("extention").content}
            </div>
          }
          header={`${
            props.selectedExtension[storeExtention.type]
              ? t("extention").deactivate
              : t("extention").activate
          } ${t("extention").extension}`}
          onConfirm={() => {
            const newExtensions = extensions.map((ext) => {
              if (ext.id === storeExtention.id) {
                return {
                  ...ext,
                  enabled: !ext.enabled,
                };
              }
              return ext;
            });
            props.updateExtension(
              newExtensions,
              setIsOpenConfirmationModal,
              storeExtention,
              userInput,
              captchaText,
              canvasRef,
              initializeCaptcha
            );
          }}
          onCancel={() => {
            setIsOpenConfirmationModal(false);
            props.setCheckInputCaptchaBlankOrNot(false);
          }}
        />
      )}
      <div className="container">
        <div className="row mx-n2 btsp">
          {extensions.length > 0 &&
            extensions
              .filter((data) => data.isAvailable) // Only show available extensions
              .map((data, index) => {
                const isChangedStyleWithId = [9, 10, 11, 12].includes(data.id);

                return (
                  <>
                    <div className="col-lg-2 col-sm-3 px-2">
                      <div
                        className={`card hover-shadow-lg mb-3 hover-card ${
                          props.selectedExtension[data.type] ? "active" : ""
                        }`}
                        onClick={() => {
                          setIsOpenConfirmationModal(true);
                          setStoreExtention(data);
                        }}
                      >
                        <span
                          className={`${
                            props.selectedExtension[data.type]
                              ? "active-round position-absolute top-1 left-1 p-2 border border-light rounded-circle"
                              : ""
                          }`}
                        ></span>
                        <div
                          className="card-body text-center py-4 px-0"
                          style={{ height: isChangedStyleWithId && "166px" }}
                        >
                          <div
                            className="mb-3 mt-2"
                            style={{ height: isChangedStyleWithId && "100%" }}
                          >
                            {isChangedStyleWithId ? (
                              data.isSvgComponent ? (
                                data.image
                              ) : (
                                <div style={{ height: "100%", width: "100%" }}>
                                  <img
                                    src={data.image}
                                    alt="dashboard-image"
                                    className="img-fluid"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                              )
                            ) : data.isSvgComponent ? (
                              data.image
                            ) : (
                              <div
                                className="icon icon-shape icon-lg text-white overflow-hidden"
                                style={{
                                  background: `${data.background} !important`,
                                  boxShadow: data.shadow,
                                }}
                                ref={(el) => {
                                  if (el) {
                                    el.style.setProperty('background-color', data.background, 'important');
                                  }
                                }}
                              >
                                <img
                                  src={data.image}
                                  alt="dashboard-image"
                                  style={{ width: "30px" }}
                                />
                              </div>
                            )}
                          </div>
                          {data.id !== 9 &&
                            data.id !== 10 &&
                            data.id !== 11 &&
                            data.id !== 12 && (
                              <h5 className="h5 font-weight-bolder mb-0 text-capitalize extention_name">
                                {data.name}
                              </h5>
                            )}
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
        </div>
      </div>
    </>
  );
}

export default ACVExtension;
